import { render, staticRenderFns } from "./brandIndex.vue?vue&type=template&id=03f2043c&"
import script from "./brandIndex.vue?vue&type=script&lang=ts&"
export * from "./brandIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports